import React from "react";
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, {tableCellClasses} from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import {styled} from "@mui/material/styles";
import Api, {APIs} from "../../../../Api";
import {makeHeading} from "../../../digitalarz/data-grid/components/utils";

export const StyledTableCell = styled(TableCell)(({theme}) => ({
    [`&.${tableCellClasses.head}`]: {
        backgroundColor: theme.palette.common.black,
        color: theme.palette.common.white,
    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: 14,
    },
}));

export const StyledTableRow = styled(TableRow)(({theme}) => ({
    '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.action.hover,
    },
    // hide last border
    '&:last-child td, &:last-child th': {
        border: 0,
    },
}));


const SROInfo = () => {
    const [sroInfo, setSROInfo] = React.useState([])
    React.useEffect(() => {
        Api.get(APIs.MoPD_SRO_INFO).then((payload) => {
            if (payload) {
                setSROInfo(payload)
            }
        });
    }, [])
    return (
        <React.Fragment>
            <Table sx={{minWidth: 700}} aria-label="sro-info table">
                <TableHead>
                    <TableRow>
                        {sroInfo.length > 0 && Object.keys(sroInfo[0]).map((key) => <StyledTableCell
                            key={"head-" + key}>{makeHeading(key)}</StyledTableCell>)}
                    </TableRow>
                </TableHead>
                <TableBody>
                    {sroInfo.map((row, index) => (
                        <StyledTableRow key={"row-" + index}>
                            {sroInfo.length > 0 && Object.keys(sroInfo[0]).map((key) => <StyledTableCell
                                key={`row-${index}-${key}`}>{row[key]}</StyledTableCell>)}

                        </StyledTableRow>
                    ))}
                </TableBody>
            </Table>
        </React.Fragment>
    )
}

export default SROInfo
